import { createSelector } from "reselect";
import { populationIncidenceChartDataSelector } from "../population_incidence_chart_data_selector";

export const populationIncidenceChartDataLoadStateSelector = createSelector(
  populationIncidenceChartDataSelector,
  chartData => chartData.loadState
);
